import React, { useState, useEffect, useRef } from 'react';
import './ModalMiltilevelSidebarSettings.scss';
import customHeaders, { getSpace } from '../../../common/headers';
import { RavshanHttps } from '../../../fetchUrls';
import useGeneralStore from '../../../store/general';
import { useNavigate, useParams } from 'react-router-dom';
import { SceletonMultilevelSidebar, ButtonBasic, InputDynamicWidth } from '@lk-gtcom/ecomlab-components';
import drop_icon from './img/drop_icon.svg';
import { TextPage } from '../../TextPage/TextPage';
import { ModalAddMenuItem } from './ModalAddMenuItem/ModalAddMenuItem';
import { ModalEditMenuItem } from './ModalEditMenuItem/ModalEditMenuItem';
import { ModalAddFileToken } from './ModalAddFileToken/ModalAddFileToken';
import { ModalDeleteFileToken } from './ModalDeleteFileToken/ModalDeleteFileToken';
import { ModalAddPermission } from './ModalAddPermission/ModalAddPermission';
import { ButtonActionDrop } from '../../Buttons/ButtonActionDrop/ButtonActionDrop';
import { useLocation } from 'react-router-dom';

// Импорт изображений
import userIcon from './img/bx-user.svg';
import userCircleIcon from './img/bx-user-circle.svg';
import notAccessIcon from './img/not-access.svg'

const MenuItem = ({
  item,
  onDragStart,
  onDragOver,
  onDrop,
  onDropFile,
  onDropBetween,
  toggleExpand,
  handleAddChild,
  handleSelect,
  handleDelete,
  selectedItemId,
  fetchChildren,
  setIsModalSettings,
  fetchGetBreadcrumbs,
  expanded,
  toggleExpandItem,
  readonly,
  setCurrentPoint,
  directory,
  setIsModalAddPermission,
  setIsModalAddToken,
  setIsModalDeleteToken,
  setSelectedDirectory,
  setCurrentPermission
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isHoveredTop, setIsHoveredTop] = useState(false);
  const [isHoveredForDrop, setIsHoveredForDrop] = useState(false);

  const path = useParams()['*'];
  const current_directory = path?.split('/').at(-2)

  // Права на перемещение директории
  const can_manage = (item.client_role === 'owner') || (item.client_role === 'collaborator')

  // Проверка можно ли переносить в этот элемент
  const canDrop = directory ? can_manage : true;

  const handleToggleExpand = () => {
    // Переключаем состояние раскрытия
    toggleExpandItem(item.id, !expanded[item.id]);
    if (!expanded) {
      fetchChildren(item.id); // Сделать запрос для детей этого элемента
    }
  };

  useEffect(() => {
    if (expanded && expanded?.[item.id]) {
      fetchChildren(item.id);
    }
  }, [item]);

  const btns = [
    ...(directory) ?
      [
        {
          btn: 'Добавить права', func: (e) => {
            setSelectedDirectory(e)
            setIsModalAddPermission(true)
          }
        },
        {
          btn: 'Создать токен', func: (e) => {
            setSelectedDirectory(e)
            setIsModalAddToken(true)
          }
        },
        {
          btn: 'Удалить токен', func: (e) => {
            setSelectedDirectory(e)
            setIsModalDeleteToken(true)
          }
        },
      ]
      :
      [],
    {
      btn: 'Копировать id', func: () => {
        navigator.clipboard.writeText(`/articles/${item.id}`)
        alert(`Скопировано /articles/${item.id}`)
      }
    },
    {
      btn: 'Редактировать', func: () => {
        setCurrentPoint(item)
        setIsModalSettings(true)
      }
    },
    { btn: 'Удалить', func: () => { handleDelete(item.id) } },
  ];

  return (
    <>
      <div
        onDragOver={(e) => onDragOver(e)}
        onDrop={(e) => canDrop && onDropBetween(e, item.id, 'above')}
      />

      <div
        className={`menu-item`}
        draggable={(!readonly && !directory) && true}
        onDragStart={(e) => {
          onDragStart(e, item.id);
        }}
        onDragOver={(e) => {
          e.preventDefault();
          onDragOver(e);
          e.dataTransfer.dropEffect = 'move';
          // Подсвечиваем только текущий элемент, не трогая родительские
          if (canDrop) {
            setIsHoveredForDrop(true);
          }
          // Останавливаем всплытие, чтобы событие не доходило до родительских элементов
          e.stopPropagation();
        }}
        onDrop={(e) => {
          e.stopPropagation()
          if (canDrop) {
            onDrop(e, item.id, 'inside', item.parent_id);

            // для директории
            if (directory) {
              if (item.client_role == 'collaborator' || item.client_role == 'owner') {
                onDropFile(current_directory, item.id)
              } else {
                alert('Чтобы перенести файлы в указанную папку, вы должны быть ее автором или соавтором')
              }
            }
          }

          setIsHoveredForDrop(false);
        }}
        onDragLeave={() => {
          setIsHoveredForDrop(false);
        }}
        onClick={(e) => {
          e.stopPropagation();
          handleSelect(item.id, item?.client_role);
        }}
      >
        <div
          className={`item-label ${isHoveredForDrop && canDrop ? 'hovered-for-drop' : ''}`}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            color: selectedItemId === item.id ? '#00B45E' : '',
            position: 'relative'
          }}
          onDragEnter={(e) => {
            e.preventDefault();
            // Не передаем событие дальше
            e.stopPropagation();
            if (canDrop) {
              setIsHoveredForDrop(true);
            }
          }}
        >
          {
            (item.before === null && item.parent_id === null && !directory && canDrop) &&
            <div
              className="hover-block"
              style={{
                height: '4px',
                borderTop: isHoveredTop ? '4px solid #5282ff' : '',
                top: 0,
                //  backgroundColor: isHovered ? '#5282ff' : 'rgb(255, 180, 82)',
              }}
              onDragEnter={(e) => {
                e.stopPropagation();
                setIsHoveredTop(true);
              }}
              onDragLeave={(e) => {
                e.stopPropagation();
                setIsHoveredTop(false);
              }}
              onDragOver={(e) => {
                e.preventDefault();
                onDragOver(e);
                e.dataTransfer.dropEffect = 'move';
                e.stopPropagation();
              }}
              onDrop={(e) => {
                e.stopPropagation()
                if (canDrop) {
                  onDropBetween(e, item.before, 'above', item.parent_id);
                }
                setIsHoveredTop(false);
              }}
            />}

          <div className="item-label__box">
            <div className="menu-item__arrow-box">
              {(item.has_child || item.children.length > 0) && (
                <img
                  src={drop_icon}
                  className={`arrow ${expanded[item.id] ? 'open' : ''}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (expanded[item.id]) {
                      handleToggleExpand()
                    } else {
                      fetchChildren(item.id);
                      handleToggleExpand()
                    }
                  }}
                />
              )}
            </div>
            <span
              onClick={() => {
                fetchGetBreadcrumbs(item.id)
              }}
            >{item.label}</span>

            {!readonly && <div className="menu-item__group-btn">

              {directory && <>
                {item?.client_role === 'owner' && <img src={userCircleIcon} alt="Автор" />}
                {item?.client_role === 'collaborator' && <img src={userIcon} alt="Соавтор" />}
                {!item?.has_access && <img src={notAccessIcon} alt="Соавтор" />}
              </>}

              {(directory ? (item?.client_role === 'collaborator' || item?.client_role === 'owner') : true) &&
                <ButtonActionDrop id={item.id} btns={btns} size={'s'} />}
            </div>}
          </div>

          {/* {!item.expanded && ( */}
          {!directory && canDrop && (
            <div
              className="hover-block"
              style={{
                borderTop: isHovered ? '4px solid #5282ff' : '',
                height: '4px',
                bottom: 0,
              }}
              onDragEnter={(e) => {
                e.stopPropagation();
                setIsHovered(true);
              }}
              onDragLeave={(e) => {
                e.stopPropagation();
                setIsHovered(false);
              }}
              onDragOver={(e) => {
                e.preventDefault();
                onDragOver(e);
                e.dataTransfer.dropEffect = 'move';
                e.stopPropagation();
              }}
              onDrop={(e) => {
                e.stopPropagation();
                if (canDrop) {
                  onDropBetween(e, item.id, 'below', item.parent_id);
                }
                setIsHovered(false);
              }}
            />
          )}
          {/* )} */}
        </div>

        {expanded[item.id] && item.children.length > 0 && (
          <div className="children">
            {item.children.map((child, ind) => (
              <MenuItem
                ind={ind}
                key={child.id}
                item={child}
                onDragStart={onDragStart}
                onDragOver={onDragOver}
                onDrop={onDrop}
                onDropBetween={onDropBetween}
                toggleExpand={toggleExpand}
                handleAddChild={handleAddChild}
                handleDelete={handleDelete}
                handleSelect={handleSelect}
                selectedItemId={selectedItemId}
                fetchChildren={fetchChildren}
                setIsModalSettings={setIsModalSettings}
                expanded={expanded}
                toggleExpandItem={toggleExpandItem}
                readonly={readonly}
                fetchGetBreadcrumbs={fetchGetBreadcrumbs}
                setCurrentPoint={setCurrentPoint}
                directory={directory}
                setIsModalAddPermission={setIsModalAddPermission}
                setSelectedDirectory={setSelectedDirectory}
                setCurrentPermission={setCurrentPermission}
                setIsModalAddToken={setIsModalAddToken}
                setIsModalDeleteToken={setIsModalDeleteToken}
                onDropFile={onDropFile}
              />
            ))}
          </div>
        )}
      </div >
    </>
  );
};

const ModalMiltilevelSidebarSettings = ({
  setTitle = () => { },
  setPathsWebName = () => { },
  onPortalClick,
  setPaths = () => { },
  selectedItemId,
  setSelectedItemId,
  fetchGetBreadcrumbs = () => { },
  breadcrumbs = [],
  directory,
  readonly,
  tokenWiki,
  stopRedirect,
  pathBread = '',
  dragArticle,
  setDragArticle = () => { },
  fileSystemId = false,
  isSearching = false,
  wikiId,
  setCurrentPermission = () => { },

  // массовое перемещение директории 
  checkList = [],
  setCheckList = () => { },
  onDropFile = () => { },
}) => {
  // Состояние для хранения раскрытых пунктов меню
  const [expandedItemsStorage, setExpandedItemsStorage] = useState({});
  // Функция для переключения состояния раскрытия
  const toggleExpandItems = (itemId, isExpanded) => {
    if (itemId) {
      setExpandedItemsStorage((prevState) => ({
        ...prevState,
        [itemId]: isExpanded,  // Устанавливаем значение true или false для текущего элемента
      }));
    }
  };

  // console.log(expandedItemsStorage)
  const location = useLocation()
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };

  const [menu, setMenu] = useState([]);
  const [draggedItemId, setDraggedItemId] = useState(null);
  const [token, setToken] = useState(tokenWiki)
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [selectedDirectory, setSelectedDirectory] = useState(null)

  // Modal
  const [isModalSettings, setIsModalSettings] = useState(false);
  const [isModalAddPermission, setIsModalAddPermission] = useState(false);
  const [isModalAddToken, setIsModalAddToken] = useState(false);
  const [isModalDeleteToken, setIsModalDeleteToken] = useState(false);

  const [newItemLabel, setNewItemLabel] = useState('');
  // const [selectedItemId, setSelectedItemId] = useState(null);
  const [isLoadingChildren, setIsLoadingChildren] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const wiki_name = localStorage.getItem('wiki_name');
  const wiki_id = directory ? null : (wikiId ? wikiId : localStorage.getItem('wiki_id'));
  const path = useParams()['*'];

  const [selectedLang, setSelectedLang] = useState('ru');
  const [isLanguage, setIsLanguage] = useState(false);

  const [search, setSearch] = useState('')
  const [currentPoint, setCurrentPoint] = useState(null)

  const menuRef = useRef(null);

  const getExpandedFromStorage = () => {
    const expandedItems = localStorage.getItem('expandedItems');
    return expandedItems ? JSON.parse(expandedItems) : [];
  };


  // const saveExpandedToStorage = (expandedItems) => {
  //   localStorage.setItem('expandedItems', JSON.stringify(expandedItems));
  // };

  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (menuRef.current && !menuRef.current.contains(event.target)) {
  //       setSelectedItemId(null);
  //     }
  //   };

  //   document.addEventListener('mousedown', handleClickOutside);
  //   return () => {
  //     document.removeEventListener('mousedown', handleClickOutside);
  //   };
  // }, [menuRef]);

  const findItemById = (items, id) => {
    for (let item of items) {
      if (item.id === id) return item;
      if (item.children) {
        const found = findItemById(item.children, id);
        if (found) return found;
      }
    }
  };

  const findAndRemoveItem = (items, id) => {
    for (let i = 0; i < items.length; i++) {
      if (items[i].id === id) return items.splice(i, 1)[0];
      if (items[i].children) {
        const found = findAndRemoveItem(items[i].children, id);
        if (found) return found;
      }
    }
  };

  const addItemToParent = (items, targetId, item) => {
    for (let i = 0; i < items.length; i++) {
      if (items[i].id === targetId) {
        if (!items[i].children) items[i].children = [];
        items[i].children.push(item);
        items[i].expanded = true;
        return;
      }
      if (items[i].children) {
        addItemToParent(items[i].children, targetId, item);
      }
    }
  };

  const isChildOf = (childId, parentId, items) => {
    for (let item of items) {
      if (item.id === parentId) {
        return item.children.some((child) => child.id === childId);
      }
      if (item.children) {
        if (isChildOf(childId, parentId, item.children)) return true;
      }
    }
    return false;
  };

  const addItemAsSibling = (items, targetId, item, position) => {
    for (let i = 0; i < items.length; i++) {
      if (items[i].id === targetId) {
        const index = i;
        if (position === 'above') {
          items.splice(index, 0, item);
        } else if (position === 'below') {
          items.splice(index + 1, 0, item);
        }
        return;
      }
      if (items[i].children) {
        addItemAsSibling(items[i].children, targetId, item, position);
      }
    }
  };

  const fetchArticlesByLevelWithToken = (parent = null) => {
    setIsLoadingChildren(true);

    let curr_token = token

    // const url = `${RavshanHttps}/api/v2/article/levels/${wiki_id}`;
    const url = `${RavshanHttps}/api/v2/article/portals_levels/${curr_token}`;
    const parentsHeader = parent ? { 'parent-id': parent } : '';
    const getHeaders = { ...headers, ...parentsHeader };

    fetch(url, { headers: getHeaders })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          throw new Error(JSON.stringify(err));
        }
      })
      .then((json) => {
        const expandedItems = getExpandedFromStorage();
        const transformedData = json.map(({ id, name, has_child, subItems, before, parent_id, web_name }) => ({
          id,
          before,
          label: name,
          has_child,
          before,
          parent_id,
          web_name,
          children:
            subItems && subItems.length > 0
              ? subItems.map((subItem) => ({
                id: subItem.id,
                label: subItem.name,
                children: [],
                has_child: subItem.has_child,
                before: subItem.before,
                parent_id: id,
              }))
              : [],
          expanded: expandedItems.includes(id),
        })
        );

        transformedData.forEach((item) => {
          if (item.expanded) {
            fetchChildren(item.id);
          }
        });

        if (parent) {
          setMenu((prevMenu) => {
            const newMenu = [...prevMenu];
            const parentItem = findItemById(newMenu, parent);
            if (parentItem) {
              parentItem.children = transformedData;
              parentItem.expanded = true;
            }
            return newMenu;
          });
        } else {
          setMenu(transformedData);
        }
      })
      .catch((err) => console.error(err))
      .finally(() => {
        setIsLoadingChildren(false);
      });
  };

  const fetchArticlesByLevelWithoutToken = (parent = null) => {
    if (directory) {
      if (!fileSystemId) return
    }
    if(!directory && !wiki_id) return
    if (!parent) {
      setIsLoading(true);
    }
    setIsLoadingChildren(true);

    const file_system_id = directory ? `file_system_id=${fileSystemId}` : ''

    let url = directory ?
      `https://apps2.ecomru.ru:4460/api/v1/directory/tree?${file_system_id}${parent ? `${file_system_id ? '&' : '?'}parent_id=${parent}` : ''}`
      :
      `${RavshanHttps}/api/v2/article/levels/${wiki_id}`

    const parentsHeader = parent ? { 'parent-id': parent } : '';
    const getHeaders = { ...headers, ...parentsHeader };

    fetch(url, { headers: getHeaders })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          throw new Error(JSON.stringify(err));
        }
      })
      .then((json) => {
        const expandedItems = getExpandedFromStorage();
        const transformedData = json.map(({ id, name, has_child, subItems, before, parent_id, web_name, client_role, has_access }) => ({
          id,
          before,
          label: name,
          has_child,
          before,
          parent_id,
          web_name,
          client_role,
          has_access,
          children:
            subItems && subItems.length > 0
              ? subItems.map((subItem) => ({
                id: subItem.id,
                label: subItem.name,
                children: [],
                has_child: subItem.has_child,
                before: subItem.before,
                parent_id: id,
              }))
              : [],
          expanded: expandedItems.includes(id),
        })
        );

        transformedData.forEach((item) => {
          if (item.expanded) {
            fetchChildren(item.id);
          }
        });

        if (parent) {
          setMenu((prevMenu) => {
            const newMenu = [...prevMenu];
            const parentItem = findItemById(newMenu, parent);
            if (parentItem) {
              parentItem.children = transformedData;
              parentItem.expanded = true;
            }
            return newMenu;
          });
        } else {
          setMenu(transformedData);
        }
      })
      .catch((err) => console.error(err))
      .finally(() => {
        setIsLoadingChildren(false);
        setIsLoading(false);
      });
  };

  const fetchArticlesByLevel = token ? fetchArticlesByLevelWithToken : fetchArticlesByLevelWithoutToken

  // Получение токена для wiki
  const fetchProductIds = (id) => {
    const url = ` https://portals.ecomru.ru/api/v2/article/wiki_token?wiki_id=${id}`
    fetch(url, { method: 'GET', headers })
      .then(async res => {
        if (res.ok) {
          return res.json()
        }
        else {
          const text = await res.json()
          throw new Error(text?.detail)
        }
      })
      .then(json => {
        if (json) {
          setToken(json)
        }
      })
      .catch(err => console.error(err))
  }

  const fetchSearchMenuItems = (parent = null) => {
    setIsLoadingChildren(true);

    let curr_token = token

    // const url = `${RavshanHttps}/api/v2/article/levels/${wiki_id}`;
    const url = ` https://portals.ecomru.ru/api/v2/article/search_levels?token=${token}&search=${search}`;
    const parentsHeader = parent ? { 'parent-id': parent } : '';
    const getHeaders = { ...headers, ...parentsHeader };

    fetch(url, { headers: getHeaders })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          throw new Error(JSON.stringify(err));
        }
      })
      .then((json) => {
        const expandedItems = getExpandedFromStorage();
        const transformedData = json.map(({ id, name, has_child, subItems, before, parent_id, web_name }) => ({
          id,
          before,
          label: name,
          has_child,
          before,
          parent_id,
          web_name,
          children:
            subItems && subItems.length > 0
              ? subItems.map((subItem) => ({
                id: subItem.id,
                label: subItem.name,
                children: [],
                has_child: subItem.has_child,
                before: subItem.before,
                parent_id: id,
              }))
              : [],
          expanded: expandedItems.includes(id),
        })
        );

        transformedData.forEach((item) => {
          if (item.expanded) {
            fetchChildren(item.id);
          }
        });

        if (parent) {
          setMenu((prevMenu) => {
            const newMenu = [...prevMenu];
            const parentItem = findItemById(newMenu, parent);
            if (parentItem) {
              parentItem.children = transformedData;
              parentItem.expanded = true;
            }
            return newMenu;
          });
        } else {
          setMenu(transformedData);
        }
      })
      .catch((err) => console.error(err))
      .finally(() => {
        setIsLoadingChildren(false);
      });
  };

  const fetchChildren = (parentId) => {
    fetchArticlesByLevel(parentId);
  };

  // useEffect(() => {
  //   if (!fileSystemId) {
  //     fetchArticlesByLevel();
  //   }
  // }, []);

  useEffect(() => {
    if (!fileSystemId) {
      if (search && !token) {
        fetchProductIds(wiki_id)
      }
      if (search && token) {
        fetchSearchMenuItems()
      }
      if (!search) {
        fetchArticlesByLevel();
      }
    }
  }, [search, token, wiki_id]);

  useEffect(() => {
    if (fileSystemId) {
      fetchArticlesByLevel();
    }
  }, [fileSystemId]);


  const getLabelFromUrl = () => {
    const label = window.location.pathname.split('/').at(-2);
    return label;
  };

  let actualPath = getLabelFromUrl();

  useEffect(() => {
    setPaths([actualPath.replace(/%20/g, ' ')]);
  }, [actualPath]);

  const navigate = useNavigate();

  // const handleSelect = (itemId) => {
  //   const item = findItemById(menu, itemId);
  //   const label = item.label;
  //   const newUrl = `/${directory ? 'file' : 'wiki'}/${item.id}/`;
  //   navigate(newUrl);
  //   // window.history.pushState({}, '', newUrl);
  //   setSelectedItemId(itemId);
  //   setTitle(label);
  //   onPortalClick(itemId);
  //   // if (typeof setPaths === 'function') {
  //   //   setPaths([actualPath]);
  //   // }
  //   setPathsWebName(label);
  // };

  const handleSelect = (itemId, permission) => {
    const item = findItemById(menu, itemId);
    const label = item.label;

    // Сбор цепочки ID
    const idChain = getParentIdChain(menu, itemId);

    // Формирование URL
    const newUrl = `/${directory ? 'file' : 'wiki'}/${itemId}/`;
    if (!stopRedirect) {
      navigate((pathBread ? '/' : '') + pathBread + newUrl);
    }

    setSelectedItemId(itemId);
    setTitle(label);
    onPortalClick(itemId);
    setCurrentPermission(permission)
    setPathsWebName(label);
  };

  // Функция для сбора цепочки ID родительских элементов
  const getParentIdChain = (items, itemId, chain = []) => {
    for (let item of items) {
      if (item.id === itemId) {
        return [...chain, directory ? item.id : item.web_name];
      }
      if (item.children) {
        const found = getParentIdChain(item.children, itemId, [...chain, directory ? item.id : item.web_name]);
        if (found) return found;
      }
    }
    return null;
  };

  // Обновляем крошки при первой загрузке
  useEffect(() => {
    const currentURL = window.location.href;
    const id = currentURL.split('/').at(-2)
    if (currentURL.split('/').at(-1) != 'wiki') {
      fetchGetBreadcrumbs(id)
      onPortalClick(id)
    }
  }, []);

  const [initial, setInitial] = useState(true)


  // Эффект для открытия меню при загрузке
  useEffect(() => {
    if (initial && (breadcrumbs.length > 0)) {
      const obj_expanded = {}
      breadcrumbs?.forEach(({ value, label }, ind) => {
        fetchChildren(value)
        if (ind == breadcrumbs.length - 1) {
          if (!location.pathname.includes('/article/')) {
            setSelectedItemId(value)
            setTitle(label)
          }
        } else {
          obj_expanded[value] = true

        }
      })
      setExpandedItemsStorage(obj_expanded)
      setInitial(false)
    }
  }, [breadcrumbs, window.location.href]);


  const toggleExpand = (id, expanded) => {
    const newMenu = [...menu];
    // const expandedItems = getExpandedFromStorage();

    // if (expanded) {
    //   if (!expandedItems.includes(id)) {
    //     expandedItems.push(id);
    //   }
    // } else {
    //   const index = expandedItems.indexOf(id);
    //   if (index > -1) {
    //     expandedItems.splice(index, 1);
    //   }
    // }

    // saveExpandedToStorage(expandedItems);

    // toggleExpandItem(newMenu, id, expanded);
    setMenu(newMenu);
  };

  const toggleExpandItem = (items, id, expanded) => {
    for (let i = 0; i < items.length; i++) {
      if (items[i].id === id) {
        items[i].expanded = expanded;
        return;
      }
      if (items[i].children) {
        toggleExpandItem(items[i].children, id, expanded);
      }
    }
  };

  const openModalToAdd = () => {
    setIsModalOpen(true);
    setNewItemLabel('');
  };

  const addNewItem = () => {
    if (!newItemLabel) return;

    const parentId = selectedItemId || null;
    fetchAddLevel(newItemLabel, parentId, null)
      .then((newItem) => {
        const newMenu = [...menu];
        const newMenuItem = {
          id: newItem.id,
          label: newItemLabel,
          children: [],
        };

        if (parentId) {
          addItemToParent(newMenu, parentId, newMenuItem);
        } else {
          newMenu.unshift(newMenuItem);
        }
        setMenu(newMenu);
        setIsModalOpen(false);
        setSelectedItemId(newMenuItem.id);
        fetchArticlesByLevel()
      })
      .catch((err) => console.error(err));
  };

  const fetchAddLevel = (name, parent_id, place) => {
    let url = directory ?
      'https://apps2.ecomru.ru:4460/api/v1/directory'
      :
      `${RavshanHttps}/api/v2/article/level`

    const body_wiki = JSON.stringify({
      name,
      parent_id,
      before: place,
      wiki_list_id: wiki_id,
    });

    const body_directory = JSON.stringify({
      name,
      parent_id,
      language: "ru",
      portal_id: 4,
      file_system_id: fileSystemId
    });

    return fetch(url, { body: directory ? body_directory : body_wiki, method: 'POST', headers })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error(res.json());
        }
      })
      .then(fetchArticlesByLevel())
      .catch((err) => console.error(err));
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDragStart = (e, id) => {
    setDraggedItemId(id);
    e.stopPropagation();
  };

  const handleDrop = (e, targetId) => {

    e.preventDefault();
    e.stopPropagation();
    if (dragArticle) {
      fetchChangeLevelArticle(dragArticle?.id, targetId)
    }
    if (draggedItemId === targetId) return;

    const newMenu = [...menu];

    if (isChildOf(targetId, draggedItemId, newMenu)) {
      return;
    }

    const draggedItem = findAndRemoveItem(newMenu, draggedItemId);

    if (!draggedItem) return;

    addItemToParent(newMenu, targetId, draggedItem);
    setMenu(newMenu);
    fetchChangeLevel(draggedItem.label, targetId, null, draggedItem.id);
  };

  // Изменение уровня у статьи
  const fetchChangeLevelArticle = (article_id, new_level_id) => {
    const url = ` https://portals.ecomru.ru/api/v2/article/article_level`

    const body = JSON.stringify({
      article_id: article_id,
      new_level_id: new_level_id
    })

    fetch(url, { body, method: 'PATCH', headers })
      .then(res => {
        if (!res?.ok) { throw new Error('bad response') }
        return res.json()
      })
      .then(json => {
        setDragArticle(null)
      })
      .catch(e => console.log(e))
  }

  const handleDropBetween = (e, targetId, position, parrent) => {
    e.preventDefault();
    e.stopPropagation();

    if (draggedItemId === targetId) return;

    const newMenu = [...menu];

    if (isChildOf(targetId, draggedItemId, newMenu)) {
      return;
    }

    const draggedItem = findAndRemoveItem(newMenu, draggedItemId);

    if (!draggedItem) return;
    let newParentId = null;
    let before = null;

    // родительский элемент
    if (position === 'inside') {
      newParentId = targetId;
      before = null;
    }
    // поставить выше
    if (position === 'above') {
      newParentId = parrent || null;
      before = targetId;
    }
    // поставить ниже
    if (position === 'below') {
      newParentId = parrent || null;
      before = targetId;
    }

    fetchChangeLevel(draggedItem.label, parrent, before, draggedItem.id);
    setMenu(newMenu);
  };

  const findItemParent = (items, id) => {
    for (let item of items) {
      if (item.children.some((child) => child.id === id)) return item;
      if (item.children) {
        const found = findItemParent(item.children, id);
        if (found) return found;
      }
    }
  };

  const fetchChangeLevel = (name, parent_id, place, wikiID) => {
    let url = directory ?
      `https://apps2.ecomru.ru:4460/api/v1/directory/${wikiID}`
      :
      `${RavshanHttps}/api/v2/article/level`;

    const body_wiki = JSON.stringify({
      name,
      parent_id,
      before: place || null,
      wiki_list_id: wiki_id,
      wiki_id: wikiID,
      current_parent_id: parent_id
    });

    const body_directory = JSON.stringify({
      name,
      parent_id,
      before: place,
      wiki_list_id: wiki_id,
      wiki_id: wikiID,
      // "id": 0,
      portal_id: 4,
      language: "ru",
      file_system_id: fileSystemId
    });

    fetch(url, { body: directory ? body_directory : body_wiki, method: 'PUT', headers })
      .then((res) => {
        if (res.ok) {
          fetchArticlesByLevel();
          return res.json();
        } else {
          throw new Error(res.json());
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const fetchDeleteLevel = (level_id) => {
    let url = directory ?
      `https://apps2.ecomru.ru:4460/api/v1/directory/${level_id}?file_system_id=${fileSystemId}`
      :
      `${RavshanHttps}/api/v2/article/level?wiki_list_id=${wiki_id}`;

    const _headers = {
      ...headers,
      'level-id': level_id
    };

    fetch(url, { method: 'DELETE', headers: _headers })
      .then((res) => {
        if (res.ok) {
          if (res.ok) {
            setMenu((prevState) => {
              const updatedState = removeItemFromMenu(prevState, level_id);
              return updatedState;
            });
            fetchArticlesByLevel();
            setSelectedItemId(null);
          } else {
            return res.json();
          }
        } else {
          throw new Error(res.json());
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const removeItemFromMenu = (items, id) => {
    return items.reduce((acc, item) => {
      if (item.id === id) return acc;
      if (item.children) {
        item.children = removeItemFromMenu(item.children, id);
      }
      acc.push(item);
      return acc;
    }, []);
  };

  useEffect(() => {
    if (selectedLang) {
      setIsLanguage(true);
    } else {
      setIsLanguage(false);
    }
  }, [selectedLang]);



  return (
    <div className="modal-miltilevel-sidebar-settings"
      ref={menuRef}
    >
      {!readonly && <div className="modal-miltilevel-sidebar-settings__select-container">
        <ButtonBasic
          blue
          text={`Добавить ${directory ? 'новую папку' : 'новый раздел'} `}
          width="100%"
          onClick={openModalToAdd}
        />
      </div>}

      {isLanguage && (
        <>
          {isSearching && <InputDynamicWidth
            onChange={(e) => setSearch(e)}
            position="left"
            maxWidth="100%"
            placeholder='Поиск по разделам'
            drop={false}
            isOpen={true}
          />}

          {isLoading ?
            <SceletonMultilevelSidebar />
            :
            <div className="menu">
              {menu.length ?
                menu?.map((item, ind) => (
                  <MenuItem
                    readonly={readonly}
                    fetchGetBreadcrumbs={fetchGetBreadcrumbs}
                    key={item.id + ind + item.before + item.parent_id + item.label}
                    item={item}
                    onDragStart={handleDragStart}
                    onDragOver={handleDragOver}
                    onDrop={handleDrop}
                    onDropBetween={handleDropBetween}
                    toggleExpand={toggleExpand}
                    handleAddChild={openModalToAdd}
                    handleDelete={fetchDeleteLevel}
                    handleSelect={handleSelect}
                    selectedItemId={selectedItemId}
                    fetchChildren={fetchChildren}
                    setIsModalSettings={setIsModalSettings}
                    ind={ind}
                    expanded={expandedItemsStorage} // Передаем состояние раскрытия
                    toggleExpandItem={toggleExpandItems} // Передаем функцию переключения раскрытия
                    setCurrentPoint={setCurrentPoint}
                    directory={directory}
                    setIsModalAddPermission={setIsModalAddPermission}
                    setIsModalAddToken={setIsModalAddToken}
                    setIsModalDeleteToken={setIsModalDeleteToken}
                    setSelectedDirectory={setSelectedDirectory}
                    onDropFile={onDropFile}
                  />
                ))
                :
                <TextPage
                  text='Нет данных'
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '20px',
                    textAlign: 'center',
                    height: '300px'
                  }}
                />
              }
            </div>
          }
        </>
      )}

      {isModalOpen && (
        <ModalAddMenuItem
          newItemLabe={newItemLabel}
          setIsModal={setIsModalOpen}
          addNewItem={addNewItem}
          setNewItemLabel={setNewItemLabel}
          directory={directory}
        />
      )}

      {isModalSettings && (
        <ModalEditMenuItem
          setIsModal={setIsModalSettings}
          fetchChangeLevel={fetchChangeLevel}
          currentPoint={currentPoint}
          setCurrentPoint={setCurrentPoint}
        />
      )}

      {isModalAddToken &&
        <ModalAddFileToken
          selectedDirectory={selectedDirectory}
          setSelectedDirectory={setSelectedDirectory}
          setIsModal={setIsModalAddToken}
        />
      }

      {isModalDeleteToken &&
        <ModalDeleteFileToken
          selectedDirectory={selectedDirectory}
          setSelectedDirectory={setSelectedDirectory}
          setIsModal={setIsModalDeleteToken}
        />
      }


      {isModalAddPermission &&
        <ModalAddPermission
          selectedDirectory={selectedDirectory}
          setSelectedDirectory={setSelectedDirectory}
          setIsModal={setIsModalAddPermission}
          onSuccess={() => {
            // Обновляем весь уровень меню после изменения прав
            fetchArticlesByLevel();
          }}
        />}
    </div>
  );
};

export { ModalMiltilevelSidebarSettings };
